// export interface ButtonInterface {
//   size?: 'sm' | 'md' | 'lg' | 'full'
//   style?: 'filled' | 'transparent'
//   className?: string
//   children: React.ReactNode
//   disabled?: boolean
//   type: 'button' | 'submit' | 'reset' | undefined
//   onSubmit?: (event: React.FormEvent<HTMLButtonElement>) => void
//   onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
//   fullHeight?: boolean
// }

import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/utils'

// eslint-disable-next-line react-refresh/only-export-components
export const buttonVariants = cva(
  'focus-visible:ring-ring inline-flex cursor-pointer items-center justify-center gap-2 rounded-lg text-sm font-medium whitespace-nowrap shadow-button transition-colors focus-visible:ring-1 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'border border-primary bg-primary text-white hover:bg-primary/90',
        destructive: 'border border-red-600 bg-red-600 text-white hover:bg-red-700',
        outline: 'border border-primary bg-transparent text-black',
        link: 'underline-offset-4 hover:underline',
        ghost: 'hover:bg-accent hover:text-accent-foreground'
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'size-10',
        ghost: ''
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    const Comp = 'button'
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = 'Button'

export { Button }
